import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const FEATURES = [
    {
        icon: "mdi:office-building-outline",
        title: "Multiempresa",
        description: "Gerencie várias empresas numa única conta. Alterne entre elas com um clique.",
    },
    {
        icon: "mdi:cloud-outline",
        title: "100% Cloud",
        description: "Aceda de qualquer lugar, a qualquer hora. Sem instalação, sem configuração complexa.",
    },
    {
        icon: "mdi:puzzle-outline",
        title: "Modular",
        description: "Ative apenas os módulos que precisa. Pague só pelo que utiliza e escale conforme cresce.",
    },
    {
        icon: "mdi:shield-check-outline",
        title: "Seguro",
        description: "Os seus dados são encriptados e protegidos com as melhores práticas de segurança.",
    },
    {
        icon: "mdi:headset",
        title: "Suporte dedicado",
        description: "Equipa de suporte pronta para ajudar. Resolva qualquer questão de forma rápida.",
    },
    {
        icon: "mdi:link-variant",
        title: "Integração HongaYetu",
        description: "Integrado com a plataforma HongaYetu — pagamentos, escola inteligente e mais.",
    },
];

export default function FeaturesSection() {
    return (
        <section id="funcionalidades" className="py-20 lg:py-28 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        Porquê o Logigate?
                    </h2>
                    <p className="text-lg text-gray-500 max-w-2xl mx-auto">
                        Um ERP pensado para empresas angolanas, com tudo o que precisa para crescer.
                    </p>
                </motion.div>

                {/* Features grid */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {FEATURES.map((feature, index) => (
                        <motion.div
                            key={feature.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: index * 0.08 }}
                            className="group"
                        >
                            <div className="w-14 h-14 rounded-2xl bg-blue-50 group-hover:bg-blue-100 flex items-center justify-center mb-4 transition-colors">
                                <Icon
                                    icon={feature.icon}
                                    width={28}
                                    className="text-blue-600"
                                />
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {feature.title}
                            </h3>
                            <p className="text-sm text-gray-500 leading-relaxed">
                                {feature.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
